export const text = {
  SplashImage: "Splash Image",
  TaskPoint: "Task Point",
  SplashTime: "Splash Time(in seconds)",
  GoalAttachmentSize: "Goal Attachment Size(in mb)",
  AssetTimebookingBuffer: "Asset Time booking Buffer(in minute)",
  MinimumAssetBookingTime: "Minimum Asset Booking Time(in minute)",
  OnboardingVideo: "Onboarding Video",
  Thumbnail: "Thumbnail",
  Simmesettingupdatedsuccessfully: "Simme setting updated successfully!",
  OnboardingSettingupdatedsuccessfully:
    "Onboarding Setting updated successfully!",
  SimmeSettings: "Simme Settings",
  OnboardingSetting: "Onboarding Setting",
  SelectBrandColor: "Select Brand Color",
  OtpExpirationTime: "Otp Expiration Time",
};
